/*
 * HobbsGo mobile carousel dots.
 * A navigation affordance for EXISTING scroll-snap carousels — no new content.
 * Mark a horizontal scroll track with `data-hg-carousel` and place a
 * `<nav data-hg-dots>` sibling (snippet 'hg-carousel-dots'); this builds
 * page-based dots, keeps the active dot in sync on scroll, and scrolls on
 * click/keyboard. Dots are shown only where the track actually overflows
 * (i.e. the mobile breakpoint), so desktop is unaffected.
 */
(function () {
  if (window.__hgCDots) return;
  window.__hgCDots = true;

  function pageCount(track) {
    var w = track.clientWidth;
    if (!w) return 1;
    return Math.max(1, Math.round(track.scrollWidth / w));
  }

  function activeIndex(track, total) {
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > total - 1) i = total - 1;
    return i;
  }

  function sync(track, dots) {
    var kids = dots.children;
    var i = activeIndex(track, kids.length);
    for (var j = 0; j < kids.length; j++) {
      var on = j === i;
      kids[j].classList.toggle('is-active', on);
      kids[j].setAttribute('aria-current', on ? 'true' : 'false');
    }
  }

  function build(track, dots) {
    var n = pageCount(track);
    if (n <= 1) {
      dots.innerHTML = '';
      dots.style.display = 'none';
      return;
    }
    dots.style.display = '';
    if (dots.children.length !== n) {
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hg-cdot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', (function (idx) {
          return function () {
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          };
        })(i));
        dots.appendChild(b);
      }
    }
    sync(track, dots);
  }

  function bind(track) {
    if (track.__hgBound) return;
    // Prefer the immediate next-sibling dots (robust when several carousels
    // share one parent); fall back to first dots in the parent.
    var dots = null;
    var sib = track.nextElementSibling;
    if (sib && sib.matches && sib.matches('[data-hg-dots]')) dots = sib;
    if (!dots) dots = track.parentNode && track.parentNode.querySelector('[data-hg-dots]');
    if (!dots) return;
    track.__hgBound = true;
    track.__hgDots = dots;
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { sync(track, dots); });
    }, { passive: true });
    build(track, dots);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hg-carousel]').forEach(bind);
  }

  function rebuild() {
    document.querySelectorAll('[data-hg-carousel]').forEach(function (t) {
      if (t.__hgDots) build(t, t.__hgDots);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  var rz;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(rebuild, 150);
  });

  // Theme editor: re-scan a reloaded section.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
